<section id="section-news-articles" class="row" #newsArticles [ngStyle]="sectionColor==='grey' ? {'background-color': 'rgba(216, 216, 216, 0.15)',
    color: '#4a4a4a', 'padding-bottom': 0} : {}">
    <div>
        <div class="row">
            <h2 class="heading col-xs-10 col-xs-offset-1 letter-spacing-0001">Partner with finzy for hassle free 0% finance</h2>
        </div>

        <div class="row">
            <p class="subheading-black col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
                Inviting partners across the customer facing industries viz. <b>Wellness, Fitness, Home Improvement,
                Vacations & Holidays, Education, Design Institute, Fertility centres, Lifestyle, Medical treatment,
                Vocational training, Asset Purchase, etc.</b> to partner with Finzy to offer <b>Zero (0) %</b> or <b>low interest rate</b>
                finance solutions to your retail clients
            </p>
        </div>

        <div class="row">
            <div class="col-xs-12 col-md-10 col-md-offset-1">
                <div class="articles-container">
                    <div class="partner-with-us-benefits-tile" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
                        <div class="heading">Flexible tenure</div>
                        <div class="description">Grow your business exponentially. We offer loans to your customers for tenures from 3 to 36 months</div>
                    </div>
                    <div class="partner-with-us-benefits-tile" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
                        <div class="heading">Instant eligibility check</div>
                        <div class="description">Instant Indicative Eligibility Check (within 10 seconds) tool to increase immediate enrolments</div>
                    </div>
                    <div class="partner-with-us-benefits-tile" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
                        <div class="heading">Increase conversions</div>
                        <div class="description">Upto 30-40% increase in your conversions with Zero % finance solution.</div>
                    </div>
                    <div class="partner-with-us-benefits-tile" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
                        <div class="heading">Direct payment</div>
                        <div class="description">Payment directly into your bank account, Helps you manage your cash flows better.</div>
                    </div>
                    <div class="partner-with-us-benefits-tile" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
                        <div class="heading">Improve visibility</div>
                        <div class="description">Improve visibility of your product/services through joint campaigns</div>
                    </div>
                    <div class="partner-with-us-benefits-tile" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
                        <div class="heading">Boost your working capital</div>
                        <div class="description">Allows you to improve your working capital efficiency with upfront realisations rather than periodic payments. </div>
                    </div>
                </div>
                <div class="articles-container">
                    <div class="col-12 partner-with-us-contact-us">Contact us– <span>partners@finzy.com</span> or <span>9841 800 800</span> to arrange for a demo </div>
                </div>
            </div>
        </div>
    </div>
    <div class="partner-with-us-options">
        <div class="mr-5 option col-xs-12 col-md-2 col-md-offset-1">Customised 0%  Finance Solutions</div>
        <div class="mr-5 option col-xs-12 col-md-2">With Zero Processing Fee Options</div>
        <div class="mr-5 option col-xs-12 col-md-2">100% Secured  Online Process</div>
        <div class="mr-5 option col-xs-12 col-md-1">Minimum Documents</div>
        <div class="option last-option col-xs-12 col-md-2">End to end partner support</div>
    </div>
</section>
